import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=d46c2e2c&scoped=true&"
import script from "./_id.vue?vue&type=script&lang=js&"
export * from "./_id.vue?vue&type=script&lang=js&"
import style0 from "./_id.vue?vue&type=style&index=0&id=d46c2e2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d46c2e2c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SubscribePromoHero: require('/opt/render/project/src/channels2022/src/components/subscribe-promo/SubscribePromoHero.vue').default,SubscribePromoBenefits: require('/opt/render/project/src/channels2022/src/components/subscribe-promo/SubscribePromoBenefits.vue').default,SubscribeCurations: require('/opt/render/project/src/channels2022/src/components/subscribe/SubscribeCurations.vue').default,SubscribePromoSteps: require('/opt/render/project/src/channels2022/src/components/subscribe-promo/SubscribePromoSteps.vue').default,HomeLicensing: require('/opt/render/project/src/channels2022/src/components/home-page/HomeLicensing.vue').default,SubscribePromoReady: require('/opt/render/project/src/channels2022/src/components/subscribe-promo/SubscribePromoReady.vue').default,HomePartners: require('/opt/render/project/src/channels2022/src/components/home-page/HomePartners.vue').default})
